// extracted by mini-css-extract-plugin
module.exports = {"item":"popular-searches-list_item__JdHcO","loading":"popular-searches-list_loading__B2QT3","shine":"popular-searches-list_shine__R5cYJ"};